/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

// ******************* UNUSED ********************

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    signupRequest: ["values"],
    signupSuccess: ["response"],
    signupFailure: null
})

export const SignUpTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    success: null,
    fetching: null
})

/* ------------- Reducers ------------- */

// request signup
export const signupRequest = (state, action) => {
    const { user } = action
    return state.merge({ fetching: true ,success: null})
}

// successful login
export const signupSuccess = (state, action) => {
    const { response } = action
    const { data } = response
    const apiResponse = data
  
    
    console.tron.display({
        name: 'sign up Success',
        preview: 'You should totally suign up success this',
        value: {
            action: action,
            response: response,
            apiResponse: apiResponse
        }
    })
    return state.merge({
        fetching: false,
        error: null,
        success : true
    })
}

// failed to login
export const signupFailure = state => state.merge({ fetching: false, error: true, success: false })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [Types.SIGNUP_REQUEST]: signupRequest,
    [Types.SIGNUP_SUCCESS]: signupSuccess,
    [Types.SIGNUP_FAILURE]: signupFailure,
})
